import { render, staticRenderFns } from "./Airtag.vue?vue&type=template&id=158a5baa"
import script from "./Airtag.vue?vue&type=script&lang=js"
export * from "./Airtag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports